<section class="main-content wrapper">

  <div class="col-100">
    <div class="valet-selection">
      <ng-template [ngIf]="selected">
        <div class="heading">
          <h2><b>Valet Activities | Count: {{ valetActivities.length }}</b></h2>

          <div class="button-wrapper">
            <button class="btn hvr-grow has-margin-right" routerLink="/activities/own/storico">
              <i class="mr-10 far fa-folder"></i>Storico
            </button>
            <button class="btn hvr-grow has-margin-right" *ngIf="valetActivities.length && groups.includes('expert')" (click)="changeActivityOrderAccordingTime()"> 
              Reorder With Time
            </button>
            <button class="btn hvr-grow has-margin-right" *ngIf="valetActivities.length > 0" (click)="renderMap()" [disabled]="optimzeMap"> 
              <i matTooltip="Google Map"
                  class="material-icons action-icon"
                  style="color: #ffffff;" 
                  >location_on
              </i>
            </button>
            <button class="btn hvr-grow has-margin-right" *ngIf="valetActivities.length > 0" [disabled]="!optimzeMap" (click)="resetMap()"> 
              <i matTooltip="Reset"
                class="material-icons action-icon"
                style="color: #ffffff;"
                >refresh
              </i>
            </button>
          </div>
        </div>
      </ng-template>
      <ng-template [ngIf]="!selected">
        <div class="heading">
          <h2><b>Done Valet Activities | Count: {{ valetActivities.length }}</b></h2>
          <div class="button-wrapper">
            <button class="btn hvr-grow has-margin-right" [routerLink]="['../']" [queryParams]="{navigation: 'back'}">
              <i class="mr-10 fas fa-arrow-left"></i>Ritorna a Activities
            </button>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
    
  <br class="clear">

  <div class="filter-accordion">
    <div class="filter-accordion-header" (click)="toggleAccordion('filter')">
      <h3>FILTERS</h3>
      <i class="fas" [ngClass]="{ 'fa-chevron-down': !isFilterAccordionOpen, 'fa-chevron-up': isFilterAccordionOpen }"></i>
    </div>
    <form [formGroup]="activityFilterForm" (ngSubmit)="filter()" *ngIf="activityFilterForm">
      <div class="filter-accordion-content" [ngClass]="{ 'open': isFilterAccordionOpen }">
        <div class="filter-container">
          <div class="filter-item">
            <label for="fromDate">Delivery Date From:</label>
            <input type="date" id="fromDate" formControlName="AdminValetActivity.deliveryDate_from" placeholder="YYYY-MM-DD">
          </div>
          <div class="filter-item">
            <label for="toDate">Delivery Date To:</label>
            <input type="date" id="toDate" formControlName="AdminValetActivity.deliveryDate_to" placeholder="YYYY-MM-DD">
          </div>
          <!-- <div class="filter-item">
            <label for="partner">Partner:</label>
            <input type="text" id="partner" formControlName="Delivery.Partner.businessName" placeholder="Enter partner businessName">
          </div> -->
          <div class="filter-item">
            <label for="search">Search:</label>
            <input type="text" id="search" formControlName="AdminValetActivity.customFilter" placeholder="Enter businessName, address, product">
          </div>
        </div>
        <div class="button-container">
          <button class="btn hvr-grow"  (click)="$event.preventDefault(); filter()">
            <i class="fas fa-search"></i> 
          </button>
          <button class="btn hvr-grow has-margin-right" (click)="$event.preventDefault(); resetFilter();">
            <i class="fas fa-undo"></i> 
          </button>
        </div>
      </div>
    </form>
  </div>

  <div class="filter-accordion" *ngIf="selected">
    <div class="filter-accordion-header" (click)="toggleAccordion('optimizemap')">
      <h3>OPTIMIZE ROUTES MAP</h3>
      <i class="fas" [ngClass]="{ 'fa-chevron-down': !isOptimizeMapAccordionOpen, 'fa-chevron-up': isOptimizeMapAccordionOpen }"></i>
    </div>
    <div class="filter-accordion-content" [ngClass]="{ 'open': isOptimizeMapAccordionOpen }">
      <div class="filter-container">
        <div class="card-container map" id="optimizedMap"></div>
      </div>
    </div>
  </div>

  <div class="activities-pagination">
    <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
  </div>
  
 <div class="column-box" cdkDropList [cdkDropListData]="valetActivities" (cdkDropListDropped)="drop($event)">
  <div class="card-container" *ngFor="let valetActivity of valetActivities; index as i" cdkDrag>
    <div class="action-btns drag-icon">
      <i class="material-icons" style="cursor: move;" cdkDragHandle *ngIf="selected">reorder</i>
      <i class="material-icons loading-icon" style="color: #F44336;" *ngIf="loadingDeliveryId === valetActivity?.delivery?.id">autorenew</i>
      <ng-container *ngIf="(loadingDeliveryId !== valetActivity.delivery.id) && (selected)">
        <!-- Lock and unlock icons based on isLocked property -->
        <i matTooltip='lock' class="material-icons action-icon" style="color: #F44336;" *ngIf="valetActivity.isLocked || (valetActivity.delivery.expertIdentityCheck && (!valetActivity.delivery.expertVerified || !valetActivity.delivery.pickUpCompleted))">lock</i>
        <i matTooltip='unlock' class="material-icons action-icon" style="color: #4CAF50;" *ngIf="(valetActivity.delivery.expertIdentityCheck && valetActivity.delivery.expertVerified && valetActivity.delivery.pickUpCompleted) || (!valetActivity.delivery.expertIdentityCheck && !valetActivity.isLocked)">lock_open</i>
        <i matTooltip='map' class="material-icons action-icon" style="color: #4CAF50;" *ngIf="(!valetActivity.isLocked && (valetActivity?.activityType?.toLowerCase() === 'pickup' || valetActivity?.activityType?.toLowerCase() === 'delivery' || valetActivity?.activityType?.toLowerCase() === 'hourlyservice'))" (click)="directions($event, valetActivity)">directions</i>
        <!-- Show actions only if isLocked is false -->
        <ng-container *ngIf="!valetActivity.isLocked">
          <i [matTooltip]="deliveryStatusAux.ln('it', valetActivity?.delivery.status)"
             class="material-icons action-icon"
             style="color: #FF9800;"
             *ngIf="(valetActivity?.activityType?.toLowerCase() === 'pickup' || valetActivity?.activityType?.toLowerCase() === 'hourlyservice') && (valetActivity.delivery.status == deliveryStatus.assigned || valetActivity.delivery.status == deliveryStatus.accepted) && (valetActivity.delivery.expertIdentityCheck ? (valetActivity.delivery.expertVerified && valetActivity.delivery.pickUpCompleted) : true)"
             (click)="delivering(valetActivity.delivery.id, valetActivity.id)">
            local_shipping
          </i>
          <i [matTooltip]="deliveryStatusAux.ln('it', valetActivity?.delivery.status)"
             class="material-icons action-icon"
             style="color: #4CAF50;"
             *ngIf="(valetActivity?.activityType?.toLowerCase() === 'delivery' || valetActivity?.activityType?.toLowerCase() === 'hourlyservice') && (valetActivity.delivery.status == deliveryStatus.delivering)"
             (click)="delivered(valetActivity.delivery.id, valetActivity.id)">
            check_circle
          </i>
          <i [matTooltip]="'Non consegnata'"
             class="material-icons action-icon"
             style="color: #F44336;"
             *ngIf="(valetActivity?.activityType?.toLowerCase() === 'delivery' || valetActivity?.activityType?.toLowerCase() === 'hourlyservice') && (valetActivity.delivery.status == deliveryStatus.delivering)"
             (click)="notDelivered(valetActivity.delivery, valetActivity.id)">
            cancel
          </i>
          <a [href]="'tel:' + valetActivity?.delivery?.receiverPhone" *ngIf="valetActivity?.delivery?.receiverPhone && valetActivity?.activityType?.toLowerCase() === 'delivery'">
            <i class="material-icons" style="color: #007BFF;">
              phone
            </i>
          </a>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="!selected">
        <i matTooltip="Completato"
           class="material-icons action-icon"
           style="color: #4CAF50;"
           >check_circle
        </i>
        <i 
          class="material-icons action-icon"
          matTooltip="Cambia Ora" 
          (click)="changeStartAndEndTime(valetActivity.delivery.id)" 
          *ngIf="valetActivity?.activityType?.toLowerCase() === 'hourlyservice' && valetActivity?.delivery.service != 22"
          >manage_history
        </i>
        <i 
          class="material-icons action-icon"
          matTooltip="Cambia Ora" 
          (click)="changeTimings(valetActivity?.delivery)" 
          *ngIf="valetActivity?.activityType?.toLowerCase() === 'hourlyservice' && valetActivity?.delivery?.service == 22 && (valetActivity?.delivery?.approvedTimingStatus === null || valetActivity?.delivery?.approvedTimingStatus == 3)"
          >manage_history
        </i>
      </ng-container>

      <a matTooltip="Go to Consegna" class="action-icon" style="color: #F44336;" [href]="'/consegne/' + valetActivity.delivery.id" target="_blank">
        <i class="material-icons">open_in_new</i>
      </a>

      <i *ngIf="valetActivity.delivery.notes || valetActivity.delivery.internalNotes" matTooltip="Notes" class="material-icons action-icon" style="color: #F44336;" (click)="openNotesDialauge(valetActivity.delivery)">sticky_note_2</i>

    </div>

    <div class="accordion-header" (click)="toggleAccordion('delivery', i)">
      <div class="flex-box">
        <div class="flex-col">
          <div class="accordion-img-container">
            <div class="photo-container">
              <div class="date">
                <div class="day">{{ valetActivity.deliveryDate | date: 'dd' }}</div>
                <div class="month">{{ valetActivity.deliveryDate | date: 'MMM' | uppercase }}</div>
              </div>
            </div>
            <div class="service-image-container">
              <div class="date">
                  <p>
                      <img class="service-img" [src]="showServiceDetails(valetActivity?.delivery)?.service?.image" width="50" height="50" *ngIf="showServiceDetails(valetActivity?.delivery)?.service?.image">
                  </p>
              </div>
            </div>
          </div>
          <div class="event-name">
            <span 
              [ngStyle]="{
                color: valetActivity?.activityType?.toLowerCase() === 'pickup' ? '#FFC107' : 
                      valetActivity?.activityType?.toLowerCase() === 'delivery' ? '#007BFF' : 
                      valetActivity?.activityType?.toLowerCase() === 'hourlyservice' ? '#28A745' : ''
              }">
              {{
                valetActivity?.activityType?.toLowerCase() === 'pickup' ? 'RITIRO' :
                valetActivity?.activityType?.toLowerCase() === 'delivery' ? 'CONSEGNA' :
                valetActivity?.activityType?.toLowerCase() === 'hourlyservice' ? 'SERVIZIO ORA' : ''
              }}
              {{ valetActivity?.ddtNumber ? showDeliveryAndSaleIds(valetActivity) : valetActivity?.delivery?.id }}
              <!-- : {{ valetActivity.delivery.orderId ? valetActivity.delivery.orderId + " (" + (valetActivity.delivery.id) + ")" : valetActivity.delivery.id }} -->
            </span>
          </div>
        </div>
        <div class="info-container">
          <table class="table-product" border="1">
            <thead>
                <tr>
                  <th>Product</th>
                  <th>Quantity</th>
                </tr>
            </thead>
            <tbody>
              <tr *ngFor="let dProduct of getProducts(valetActivity)">
                <td>{{ dProduct.product?.name }} - {{ dProduct?.productVariant?.variantName }}</td>
                <td>{{ dProduct?.quantity }}</td>
              </tr>
            </tbody>
          </table>
  
          <span *ngIf="((valetActivity?.activityType?.toLowerCase() === 'pickup'))">
            <b>ORA RITIRO: </b>{{ valetActivity?.delivery?.pickUpTime || "---"}}
            <br class="clear">
          </span>
          <span *ngIf="(valetActivity?.activityType?.toLowerCase() === 'delivery' || valetActivity?.activityType?.toLowerCase() === 'hourlyservice')">
            <b>ORARIO: </b>{{ formatTimeShow(valetActivity?.delivery?.fromTime, valetActivity?.delivery?.toTime) }}
            <br class="clear">
          </span>
          <span>
            <b>PARTNER: </b>{{ valetActivity?.delivery?.partner?.businessName || "---"}}
            <br class="clear">
          </span>
          <span *ngIf="valetActivity?.activityType?.toLowerCase() === 'pickup' || valetActivity?.activityType?.toLowerCase() === 'hourlyservice'">
            <b>INDIRIZZO DI RITIRO:: </b>{{ (valetActivity?.delivery?.pickUpAddress) }}
            <br class="clear">
          </span>
          <span *ngIf="valetActivity?.activityType?.toLowerCase() === 'delivery' || valetActivity?.activityType?.toLowerCase() === 'pickup' || valetActivity?.activityType?.toLowerCase() === 'hourlyservice'">
            <b>INDIRIZZO: </b>{{ (valetActivity?.delivery?.address) }}
            <br class="clear">
          </span>
          <span>
            <b>STATO: </b>{{deliveryStatusAux.ln('it', valetActivity?.delivery?.status)}}
            <br class="clear">
          </span>
        </div>
      </div>
      <div class="toggle-icon">
        <i class="material-icons" [ngClass]="{'rotate-icon': activeAccordionIndex === i}">expand_more</i>
      </div>
    </div>

    <div class="accordion-body" *ngIf="activeAccordionIndex === i">
      <div class="additional-info">
        <p>
          <img class="service-img" [src]="showServiceDetails(valetActivity?.delivery)?.service?.image" width="50" height="50" *ngIf="showServiceDetails(valetActivity?.delivery)?.service?.image">
        </p>
        <p><strong>ORARIO:</strong> <b>{{ formatTimeShow(showingDelivery.fromTime, showingDelivery.toTime) }}</b></p>
        <p *ngIf="!showingDelivery?.customer"><strong>NOME E COGNOME: </strong> <b>{{ showingDelivery?.name || "---" }}  {{ showingDelivery?.surname || "---" }}</b></p>
        <p *ngIf="showingDelivery?.customer"><strong>NOME E COGNOME: </strong> <b>{{ showingDelivery?.customer?.user?.name || "---" }}  {{ showingDelivery?.customer?.user?.surname || "---" }}</b></p>
        <p *ngIf="!showingDelivery?.customer"><strong>CITOFONO: </strong> <b>{{ showingDelivery?.intercom || "---" }}</b></p>
        <p *ngIf="showingDelivery?.customer"><strong>CITOFONO: </strong> <b>{{ showingDelivery?.customer?.intercom || "---" }}</b></p>
        <p><strong>PARTNER:</strong> {{ showingDelivery.partner?.businessName }}</p>
        <p><strong>INDIRIZZO:</strong> {{((showingDelivery.address ? showingDelivery.address : "") + (showingDelivery.city ? ", " + showingDelivery.city : "")) || "---"}}</p>
        <p><strong>INDIRIZZO DI RITIRO:</strong> {{showingDelivery?.pickUpAddress || "---"}}</p>
        <p><strong>ORA RITIRO:</strong> <b>{{ showingDelivery?.pickUpTime || "---"}}</b></p>
        <p><strong>NOTE:</strong> <b>{{ showingDelivery?.notes || "---"}}</b></p>
        <p>
          <strong>TIPO SERVIZIO:</strong> 
          {{ showingDelivery?.serviceType &&
            (showingDelivery?.serviceType?.toLowerCase() === "fixedprice" ? "Servizi a Prezzo Fisso" :
            (showingDelivery?.serviceType?.toLowerCase() === "hourlyrate" ? "Servizi a Ora" :
            (showingDelivery?.serviceType?.toLowerCase() === "sales" ? "Servizi Vendita" : ""))) 
          }}           
        </p>
        <p *ngIf="showingDelivery?.receiverPhone && valetActivity?.activityType?.toLowerCase() === 'delivery' && !showingDelivery?.customer"><strong>TELEFONO:</strong> {{ showingDelivery?.receiverPhone || "---"}}</p>
        <p *ngIf="showingDelivery?.receiverPhone && valetActivity?.activityType?.toLowerCase() === 'delivery' && showingDelivery?.customer"><strong>TELEFONO:</strong> {{ showingDelivery?.customer?.phone || "---"}}</p>
      </div>
    </div>
  </div>
 </div>
</section>